(() => {
  // src/plp-theme-chooser.ts
  (() => {
    const selectActiveCard = (carouselEl, handle) => {
      const section = carouselEl.closest(".plp-theme-chooser");
      if (!section) return;
      const currentHandle = handle || section.dataset.currentCollection;
      section.querySelectorAll(".theme-choice-card--selected").forEach((c) => c.classList.remove("theme-choice-card--selected"));
      const matchingCard = currentHandle ? section.querySelector(
        `.theme-choice-card[data-collection-handle="${currentHandle}"]`
      ) : null;
      if (matchingCard) matchingCard.classList.add("theme-choice-card--selected");
      const slides = Array.from(carouselEl.querySelectorAll(".swiper-slide"));
      const currentIndex = matchingCard ? slides.findIndex((s) => s.contains(matchingCard)) : -1;
      const maxVisible = Number(section.dataset.visibleCards) || 0;
      const available = currentIndex === -1 ? slides.length : slides.length - 1;
      const count = Math.min(maxVisible, available);
      const visible = new Set();
      for (let i = 1; visible.size < count; i += 1) {
        const index = (currentIndex + i) % slides.length;
        if (index !== currentIndex) visible.add(index);
      }
      slides.forEach((slide, i) => {
        const isCurrent = i === currentIndex;
        const isTrimmed = maxVisible > 0 && !visible.has(i);
        slide.classList.toggle("carousel__slide--hidden", isCurrent || isTrimmed);
      });
      const swiper = carouselEl.swiper;
      if (swiper) swiper.update();
    };
    const loadCollection = async (handle, url, carouselEl) => {
      const mainContent = document.querySelector("#MainContent");
      if (!mainContent) {
        window.location.href = url;
        return;
      }
      try {
        const html = await window.HotelCollection.shopFetch.html("plp-collection", url);
        if (!html) return;
        const doc = new DOMParser().parseFromString(html, "text/html");
        const updateDOM = () => {
          var _a, _b;
          history.pushState({ collectionHandle: handle, url }, "", url);
          const livePlp = mainContent.querySelector(".shopify-section.plp-theme-chooser-section");
          const alreadyLoaded = new Set(
            Array.from(document.querySelectorAll("script[src]")).map((s) => s.src)
          );
          const scriptsToLoad = [];
          doc.querySelectorAll("#MainContent script[src]").forEach((s) => {
            if (!alreadyLoaded.has(s.src)) scriptsToLoad.push(s.src);
          });
          const fetchedSections = Array.from(
            doc.querySelectorAll("#MainContent > .shopify-section")
          );
          const nextNodes = fetchedSections.map((fetchedEl) => {
            if (fetchedEl.classList.contains("plp-theme-chooser-section")) {
              return livePlp;
            }
            fetchedEl.querySelectorAll("script").forEach((el) => el.remove());
            const uniqueClass = Array.from(fetchedEl.classList).find((cls) => cls.endsWith("-section") && cls !== "shopify-section");
            const existing = uniqueClass ? mainContent.querySelector(`.shopify-section.${uniqueClass}`) : null;
            if (existing) {
              existing.innerHTML = fetchedEl.innerHTML;
              return existing;
            }
            return fetchedEl;
          });
          Array.from(mainContent.querySelectorAll(":scope > .shopify-section")).filter((el) => !nextNodes.includes(el)).forEach((el) => el.remove());
          nextNodes.forEach((el) => mainContent.appendChild(el));
          (_b = (_a = window.HotelCollection).fadeInCollectionGrids) == null ? void 0 : _b.call(_a);
          scriptsToLoad.forEach((src) => {
            const script = document.createElement("script");
            script.src = src;
            script.defer = true;
            document.body.appendChild(script);
          });
          const plpSection = carouselEl == null ? void 0 : carouselEl.closest(".plp-theme-chooser");
          if (plpSection) plpSection.dataset.currentCollection = handle;
          if (carouselEl) selectActiveCard(carouselEl, handle);
        };
        if (document.startViewTransition) {
          document.startViewTransition(updateDOM);
        } else {
          updateDOM();
        }
      } catch (e) {
        window.location.href = url;
      }
    };
    document.addEventListener("click", (e) => {
      const card = e.target.closest(".theme-choice-card[data-collection-handle]");
      if (!card) return;
      const plpSection = card.closest(".plp-theme-chooser");
      const isAlreadySelected = plpSection && card.dataset.collectionHandle === plpSection.dataset.currentCollection;
      if (isAlreadySelected) {
        e.preventDefault();
        return;
      }
      e.preventDefault();
      loadCollection(
        card.dataset.collectionHandle,
        card.href,
        card.closest("[data-carousel]")
      );
    });
    window.addEventListener("popstate", (e) => {
      var _a;
      if (!((_a = e.state) == null ? void 0 : _a.collectionHandle)) {
        window.location.reload();
        return;
      }
      const carouselEl = document.querySelector(".plp-theme-chooser [data-carousel]");
      loadCollection(e.state.collectionHandle, e.state.url, carouselEl);
    });
    document.addEventListener("carousel:ready", (e) => {
      selectActiveCard(e.target, null);
    });
  })();
})();
